import produce from 'immer'

import { Types } from './actions'

const timesDefault = [
  {
    initial: '09:00:00',
    final: '10:00:00'
  },
  {
    initial: '10:00:00',
    final: '11:00:00'
  },
  {
    initial: '11:00:00',
    final: '12:00:00'
  },
  {
    initial: '13:00:00',
    final: '14:00:00'
  },
  {
    initial: '14:00:00',
    final: '15:00:00'
  },
  {
    initial: '15:00:00',
    final: '16:00:00'
  },
  {
    initial: '16:00:00',
    final: '17:00:00'
  },
  {
    initial: '17:00:00',
    final: '18:00:00'
  }
]

export const INITIAL_STATE = {
  loadings: {
    setStoreData: false,
    getStoreAvailableDates: false,
    setStoreAvailableDates: false,
    setStoreAvailableTimes: false,
    setCheckin: false,
    getAdjustSupply: false,
    getTransferStock: false,
    getDestinyStores: false,
    getStoreHistory: false,
    zipCodeData: false
  },
  errors: {
    setStoreData: false,
    getStoreAvailableDates: false,
    setStoreAvailableDates: false,
    setStoreAvailableTimes: false,
    setCheckin: false,
    getAdjustSupply: false,
    getTransferStock: false,
    getDestinyStores: false,
    getStoreHistory: false,
    zipCodeData: false
  },
  respondedData: false,
  respondedSupply: false,
  respondedAvailableDates: false,
  respondedAvailableTimes: false,
  respondedCheckin: false,
  times: timesDefault,
  stores: [],
  store: {},
  zipCodeData: '',
  storeEdit: {
    storeName: '',
    storeCellPhone: ''
  },
  supply: {},
  transferStock: {},
  destinyStores: [],
  storeHistory: []
}

export default function storeReducers (state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case Types.updateStoreEdit: {
        draft.storeEdit = action.payload?.storeEdit || {}
        break
      }
      case Types.updateStore: {
        draft.store = action.payload?.store || {}
        break
      }
      case Types.updateStores: {
        draft.stores = action.payload?.stores || []
        break
      }
      case Types.setStoreData: {
        draft.loadings.setStoreData = true
        draft.errors.setStoreData = false
        break
      }
      case Types.updateStoreData: {
        draft.loadings.setStoreData = false
        draft.errors.setStoreData = action.payload?.error || false
        draft.respondedData = false

        if (Object.keys(action.payload?.data).length > 0) {
          draft.store = { ...state.store, ...action.payload?.data }
          if (action.payload?.redirect) {
            draft.respondedData = true
          }
        }
        break
      }
      case Types.setZipCodeData: {
        draft.loadings.zipCodeData = true
        draft.zipCodeData = ''
        draft.errors.zipCodeData = false
        break
      }
      case Types.updateZipCodeData: {
        draft.loadings.zipCodeData = false
        draft.errors.zipCodeData = action.payload?.error || false

        if (action.payload?.data) {
          draft.zipCodeData = action.payload?.data
        }

        break
      }

      case Types.setStorePRMSupply: {
        draft.loadings.setStorePRMSupply = true
        draft.errors.setStorePRMSupply = false
        break
      }
      case Types.updateStorePRMSupply: {
        draft.loadings.setStorePRMSupply = false
        draft.errors.setStorePRMSupply = action.payload?.error || false
        draft.respondedSupply = false

        if (
          parseInt(action.payload?.data?.redeemedSupply) > 0 ||
          action.payload?.data?.redeemedSupplyObs
        ) {
          draft.respondedSupply = true
          draft.store = {
            ...state.store,
            ...{
              redeemedSupply: parseInt(action.payload?.data?.redeemedSupply)
            }
          }
        }
        break
      }
      case Types.getStoreAvailableDates: {
        draft.loadings.getStoreAvailableDates = true
        draft.errors.getStoreAvailableDates = false
        break
      }
      case Types.setStoreAvailableDates: {
        draft.loadings.setStoreAvailableDates = true
        draft.errors.setStoreAvailableDates = false
        break
      }
      case Types.updateGetStoreAvailableDates: {
        draft.loadings.getStoreAvailableDates = false
        draft.errors.getStoreAvailableDates = action.payload?.error || false

        let availableTimes = []
        if (action.payload?.availableTimes) {
          availableTimes = action.payload?.availableTimes.sort((a, b) => {
            return parseInt(a.initial.replace(/:/g, '')) >
              parseInt(b.initial.replace(/:/g, ''))
              ? 1
              : -1
          })
        }

        if (!action.payload?.error) {
          draft.respondedAvailableDates =
            action.payload?.respondedAvailableDates || false

          draft.store = {
            ...draft.store,
            ...{
              availableDates: action.payload?.availableDates || [],
              availableTimes: availableTimes,
              opensIn: action.payload?.opensIn || {}
            }
          }
        }
        break
      }
      case Types.updateSetStoreAvailableDates: {
        draft.loadings.setStoreAvailableDates = false
        draft.errors.setStoreAvailableDates = action.payload?.error || false
        draft.respondedAvailableDates =
          action.payload?.respondedAvailableDates || false
        break
      }
      case Types.updateStoreAvailableTimesEdit: {
        draft.times = action.payload?.times || []
        break
      }
      case Types.setStoreAvailableTimes: {
        draft.loadings.setStoreAvailableTimes = true
        draft.errors.setStoreAvailableTimes = false
        break
      }
      case Types.updateStoreAvailableTimes: {
        draft.loadings.setStoreAvailableTimes = false
        draft.errors.setStoreAvailableTimes = action.payload?.error || false

        draft.respondedAvailableTimes =
          action.payload?.respondedAvailableTimes || false
        break
      }
      case Types.setCheckin: {
        draft.loadings.setCheckin = true
        draft.errors.setCheckin = false
        break
      }
      case Types.updateCheckin: {
        draft.loadings.setCheckin = false
        draft.errors.setCheckin = action.payload?.error || false

        draft.respondedCheckin = action.payload?.respondedCheckin || false
        break
      }
      case Types.getAdjustSupply: {
        draft.loadings.getAdjustSupply = true
        break
      }
      case Types.updateAdjustSupply: {
        draft.loadings.getAdjustSupply = false
        draft.errors.getAdjustSupply = action?.payload?.error || false
        draft.supply = action?.payload?.supply || {}
        break
      }
      case Types.getTransferStock: {
        draft.loadings.getTransferStock = true
        draft.transferStock = false
        break
      }
      case Types.updateTransferStock: {
        draft.loadings.getTransferStock = false
        draft.errors.getTransferStock = action?.payload?.error || false
        draft.transferStock = action?.payload?.stock || {}
        break
      }
      case Types.getDestinyStores: {
        draft.loadings.getDestinyStores = true
        draft.errors.getDestinyStores = false
        break
      }
      case Types.updateDestinyStores: {
        draft.loadings.getDestinyStores = false
        draft.errors.getDestinyStores = action?.payload?.error || false
        draft.destinyStores = action?.payload.store || []
        break
      }
      case Types.getStoreHistory: {
        draft.loadings.getStoreHistory = true
        draft.errors.getStoreHistory = false
        break
      }
      case Types.updateStoreHistory: {
        draft.loadings.getStoreHistory = false
        draft.errors.getStoreHistory = action?.payload?.error || false
        draft.storeHistory = action?.payload.store?.stockHandlingHistory || []
        break
      }
      case Types.reset: {
        Object.keys(INITIAL_STATE).forEach((key) => {
          draft[key] = INITIAL_STATE[key]
        })
        break
      }
      default:
    }
  })
}
